import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
export function ComparisonTable() {
  const withoutKit = ['Errores en liquidaciones', 'Miedo a juicios laborales', 'Papeles desordenados', 'Resolver todo improvisando', 'Horas perdidas buscando info'];
  const withKit = ['Liquidaciones sin errores', 'Documentación que te protege', 'Legajos ordenados y digitales', 'Procesos paso a paso', 'Todo resuelto en minutos'];
  return <section className="w-full max-w-4xl mx-auto px-4 py-12" data-id="element-57" data-mp="3mdu1cwt87nk6">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10" data-id="element-58" data-mp="3mdamxq2sbhaw">
        Sin Kit RRHH en orden vs Con Kit RRHH en orden
      </h2>

      <div className="grid md:grid-cols-2 gap-4" data-id="element-59" data-mp="3dcmgphjmul8k">
        <div className="bg-red-50 border-2 border-red-200 rounded-lg p-6" data-id="element-60" data-mp="3dbb3ys87m35b">
          <h3 className="text-xl font-bold text-red-700 mb-4 flex items-center gap-2" data-id="element-61" data-mp="1wy4g8xr3dv7l">
            <XIcon className="w-6 h-6" data-id="element-62" data-mp="21z0ht4nz159u" />
            Sin Kit RRHH
          </h3>
          <ul className="space-y-3" data-id="element-63" data-mp="2dwvttqdnrbqr">
            {withoutKit.map((item, index) => <li key={index} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-64" data-mp="29w3kkx4sd6uh" data-mpi={index}>
                <XIcon className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-65" data-mp="2nwmnjpue9mps" />
                <span data-id="element-66" data-mp="2ivz0tgd77s1d">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-emerald-50 border-2 border-emerald-200 rounded-lg p-6" data-id="element-67" data-mp="2wvrmuyds5k30">
          <h3 className="text-xl font-bold text-emerald-700 mb-4 flex items-center gap-2" data-id="element-68" data-mp="2suobop6ogc84">
            <CheckIcon className="w-6 h-6" data-id="element-69" data-mp="36m341mmh5pru" />
            Con Kit RRHH
          </h3>
          <ul className="space-y-3" data-id="element-70" data-mp="36o73nsdcc2mb">
            {withKit.map((item, index) => <li key={index} className="flex items-start gap-2 text-gray-700 text-sm" data-id="element-71" data-mp="31nru7bw6jf9m" data-mpi={index}>
                <CheckIcon className="w-4 h-4 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-72" data-mp="3bl5vg49j7xhc" />
                <span data-id="element-73" data-mp="3bjcqquihbnbz">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}